"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_HOLD_REASON = void 0;
exports.ORDER_HOLD_REASON = {
    NEED_DESIGN: 'NEED_DESIGN',
    ORDER_ITEM_ISSUE: 'ORDER_ITEM_ISSUE',
    INVALID_ADDRESS: 'INVALID_ADDRESS',
    MANUAL_HOLD: 'MANUAL_HOLD'
};
//# sourceMappingURL=orderHoldReason.js.map